module.exports = __webpack_public_path__ + "img/live-limit.13a1835e.png";